import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import * as _ from "lodash";
import { remove } from "lodash";
import { environment } from "../../../environments/environment";
import { User } from "../../@core/data/users";

import { Catalog, Product } from "../../models/product.model";

import { ProductService } from "../../services/product.service";
import { DialogImagesUploadComponent } from "../dialog-images-upload/dialog-images-upload.component";
import { DialogLinkCatalogComponent } from "../dialog-link-catalog/dialog-link-catalog.component";

@Component({
  selector: "ngx-dialog-product-offline",
  templateUrl: "dialog-product-offline.component.html",
  styleUrls: ["dialog-product-offline.component.scss"],
})
export class DialogProductOfflineComponent implements OnInit {
  @Input() header: string;
  @Input() user?: User;
  @Input() mode: string;
  @Input() product: Product = new Product();

  @Input() units?: Catalog[];
  @Input() groups?: Catalog[];
  @Input() categories?: Catalog[];
  @Input() suppliers?: Catalog[];
  @Input() producers?: Catalog[];
  @Input() origins?: Catalog[];
  @Input() sizes?: Catalog[];
  @Input() colors?: Catalog[];

  @Input() products?: Product[];

  title: string = "";
  status: string = "0";
  trees: Set<string> = new Set([]);
  diaForm: FormGroup;
  submitted = false;
  loading = false;
  edited = false;
  imageURL = "";
  imagesUrl = [];
  menu = "info";
  ratePrice: number = 0;
  formatCurrency: string = environment.formatCurrency
    ? environment.formatCurrency
    : "#,###,###,###";

  constructor(
    protected ref: NbDialogRef<DialogProductOfflineComponent>,
    private fb: FormBuilder,
    private productService: ProductService,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit() {
    const titleValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const stringValidators = [
      Validators.minLength(1),
      Validators.maxLength(500),
    ];
    this.diaForm = this.fb.group({
      barcode: [],
      title: ["", titleValidators],
      unitName: [],
      price: [],
      wsPrice: [],
      costPrice: [],
      description: ["", stringValidators],
      ratePrice: [],
      stockMin: [],
      stockMax: [],
    });

    if (!this.product.expDate) {
      this.product.expDate = new Date();
    }

    if (this.product.tags && this.product.tags.length > 0) {
      var trees = new Set([]);
      this.product.tags.forEach(function (value) {
        trees.add(value);
      });
      this.trees = trees;
    } else {
      this.trees.add("SP");
    }
    if (!this.product.sourceType || this.product.sourceType == "") {
      this.product.sourceType = "document";
    }

    if (this.product.coverUrl && this.product.coverUrl != "") {
      this.imageURL = this.product.coverUrl;
    }
    if (this.product.imagesUrl && this.product.imagesUrl.length > 0) {
      this.imagesUrl = _.clone(this.product.imagesUrl);
    }
    if (!this.product.content) {
      this.product.content = "";
    }

    this.title = this.product.title ? this.product.title : "";
  }

  initNewData() {
    this.mode = "new";
    let newProd = new Product();
    newProd.shopId = this.product.shopId;
    newProd.unitId = this.product.unitId;
    newProd.unitName = this.product.unitName;
    newProd.groupId = this.product.groupId;
    newProd.groupName = this.product.groupName;
    newProd.categoryId = this.product.categoryId;
    newProd.categoryName = this.product.categoryName;
    newProd.supplierId = this.product.supplierId;
    newProd.supplierName = this.product.supplierName;
    newProd.producerId = this.product.producerId;
    newProd.producerName = this.product.producerName;
    newProd.originId = this.product.originId;
    newProd.originName = this.product.originName;

    this.product = newProd;
  }

  cancel() {
    if (this.edited) {
      this.ref.close(this.product);
    } else {
      this.ref.close();
    }
  }

  selectMenu(value) {
    this.menu = value;
  }

  submit(newData: boolean = true) {
    let genEan13 = false;

    if (!this.product.barcode || this.product.barcode === "") {
      this.product.barcode = this.productService.generateBarcodeEAN13();
      genEan13 = true;
    } else {
      this.product.barcode = this.product.barcode.trim();
    }

    this.product.title = this.title ? this.title.trim() : "";
    this.product.description = this.product.description
      ? this.product.description.trim()
      : "";
    this.product.price = this.product.price
      ? parseFloat(this.product.price.toString())
      : 0;
    this.product.wsPrice = this.product.wsPrice
      ? parseFloat(this.product.wsPrice.toString())
      : 0;
    this.product.costPrice = this.product.costPrice
      ? parseFloat(this.product.costPrice.toString())
      : 0;

    var tags: string[] = [];
    this.trees.forEach(function (item) {
      tags.push(item);
    });
    this.product.tags = tags;
    this.product.coverUrl = this.product.coverUrl ? this.product.coverUrl : "";
    this.product.content = this.product.content ? this.product.content : "";
    this.product.videoUrl = this.product.videoUrl ? this.product.videoUrl : "";
    this.product.imagesUrl = this.product.imagesUrl
      ? this.product.imagesUrl
      : [];

    this.product.unitId = this.product.unitId ? this.product.unitId : "";
    const unit = _.find(this.units, { id: this.product.unitId });
    this.product.unitName = unit
      ? unit.title
      : this.product.unitName
      ? this.product.unitName
      : "Cái";

    this.product.groupId = this.product.groupId ? this.product.groupId : "";
    this.product.groupName = _.find(this.groups, {
      id: this.product.groupId,
    })?.title;
    this.product.categoryId = this.product.categoryId
      ? this.product.categoryId
      : "";
    this.product.categoryName = _.find(this.categories, {
      id: this.product.categoryId,
    })?.title;
    this.product.supplierId = this.product.supplierId
      ? this.product.supplierId
      : "";
    this.product.supplierName = _.find(this.suppliers, {
      id: this.product.supplierId,
    })?.title;
    this.product.producerId = this.product.producerId
      ? this.product.producerId
      : "";
    this.product.producerName = _.find(this.producers, {
      id: this.product.producerId,
    })?.title;
    this.product.originId = this.product.originId ? this.product.originId : "";
    this.product.originName = _.find(this.origins, {
      id: this.product.originId,
    })?.title;
    this.product.sizeId = this.product.sizeId ? this.product.sizeId : "";
    this.product.sizeName = _.find(this.sizes, {
      id: this.product.sizeId,
    })?.title;
    this.product.colorId = this.product.colorId ? this.product.colorId : "";
    this.product.colorName = _.find(this.colors, {
      id: this.product.colorId,
    })?.title;

    if (genEan13) {
      this.mode === "edit" ? this.edit(newData) : this.create(newData);
    } else {
      const prod = _.find(this.products, { barcode: this.product.barcode });
      if (prod) {
        this.showToast(
          "warning",
          "Mã vạch (barcode) này đã tồn tại!",
          "Lưu thất bại"
        );
      } else {
        this.mode === "edit" ? this.edit(newData) : this.create(newData);
      }
    }
  }

  create(newData: boolean) {
    if (!this.submitted) {
      this.loading = true;
      this.submitted = true;

      this.productService.createOffline(this.product).subscribe(
        (data: Product) => {
          this.product = data;

          this.loading = false;
          this.submitted = false;

          if (newData) {
            this.initNewData();
          } else {
            this.ref.close(this.product);
            this.showToast("success", "Thêm mới mặt hàng", "thành công");
          }
        },
        (err) => {
          this.loading = false;
          this.submitted = false;
          console.log(err);
        }
      );
    }
  }

  edit(newData: boolean) {
    if (!this.submitted) {
      this.loading = true;
      this.submitted = true;

      this.productService.updateOffline(this.product).subscribe(
        (data) => {
          this.loading = false;
          this.submitted = false;

          this.edited = true;
          if (newData) {
            this.initNewData();
          } else {
            this.ref.close(this.product);
            this.showToast("success", "Cập nhật mặt hàng", "thành công");
          }
        },
        (err) => {
          this.loading = false;
          this.submitted = false;
          console.log(err);
          this.showToast("warning", "Cập nhật mặt hàng", "thất bại");
        }
      );
    }
  }

  //Images
  openGallery() {
    this.dialogService
      .open(DialogImagesUploadComponent, {
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.addImage(value);
        }
      });
  }

  updateImage(imageUrl) {
    if (imageUrl && imageUrl != "") {
      this.product.coverUrl = imageUrl;
      this.imageURL = imageUrl.replace("_400x400", "");
    }
  }
  removeCoverUrl() {
    this.product.coverUrl = "";
    this.imageURL = "/assets/images/image-upload-bg.jpg";
  }

  addImage(obj) {
    let imageURL = obj.value;

    if (!this.product.imagesUrl) {
      this.product.imagesUrl = [];
    }
    this.product.imagesUrl.push(imageURL);

    if (obj.isNew) {
      imageURL = imageURL.replace("_400x400", "");
    }
    this.imagesUrl.push(imageURL);
  }

  deleteImage(item) {
    remove(this.product.imagesUrl, (el) => {
      return el == item;
    });
    remove(this.imagesUrl, (el) => {
      return el == item;
    });
  }

  //Tags
  onTagRemove(tagToRemove: NbTagComponent): void {
    this.trees.delete(tagToRemove.text);
  }

  onTagAdd({ value, input }: NbTagInputAddEvent): void {
    if (value) {
      this.trees.add(value);
    }
    input.nativeElement.value = "";
  }

  // control event
  openCatalog(cat) {
    let catId = "";
    let catalogs;
    let header = "";
    switch (cat) {
      case "units":
        catId = this.product.unitId;
        catalogs = this.units;
        header = "Đơn vị tính";
        break;
      case "groups":
        catId = this.product.groupId = "";
        catalogs = this.groups;
        header = "Ngành hàng";
        break;
      case "categories":
        catId = this.product.categoryId = "";
        catalogs = this.categories;
        header = "Loại hàng";
        break;
      case "suppliers":
        catId = this.product.supplierId = "";
        catalogs = this.suppliers;
        header = "Nhà cung cấp";
        break;
      case "producers":
        catId = this.product.producerId = "";
        catalogs = this.producers;
        header = "Nhà sản xuất";
        break;
      case "origins":
        catId = this.product.originId = "";
        catalogs = this.origins;
        header = "Xuất xứ";
        break;
      case "sizes":
        catId = this.product.sizeId = "";
        catalogs = this.sizes;
        header = "Kích thước";
        break;
      case "colors":
        catId = this.product.colorId = "";
        catalogs = this.colors;
        header = "Màu sắc";
        break;
      default:
        break;
    }

    this.dialogService
      .open(DialogLinkCatalogComponent, {
        context: {
          header: `Xin vui lòng chọn ${header}.`,
          mode: cat,
          shopId: this.product.shopId,
          linkCatalogId: catId,
          catalogs: catalogs,
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          switch (cat) {
            case "units":
              this.product.unitId = value.id;
              this.product.unitName = value.id !== "" ? value.title : null;
              break;
            case "groups":
              this.product.groupId = value.id;
              this.product.groupName = value.id !== "" ? value.title : null;
              break;
            case "categories":
              this.product.categoryId = value.id;
              this.product.categoryName = value.id !== "" ? value.title : null;
              break;
            case "suppliers":
              this.product.supplierId = value.id;
              this.product.supplierName = value.id !== "" ? value.title : null;
              break;
            case "producers":
              this.product.producerId = value.id;
              this.product.producerName = value.id !== "" ? value.title : null;
              break;
            case "origins":
              this.product.originId = value.id;
              this.product.originName = value.id !== "" ? value.title : null;
              break;
            case "sizes":
              this.product.sizeId = value.id;
              this.product.sizeName = value.id !== "" ? value.title : null;
              break;
            case "colors":
              this.product.colorId = value.id;
              this.product.colorName = value.id !== "" ? value.title : null;
              break;
            default:
              break;
          }
        }
      });
  }

  removeCatalog(cat) {
    switch (cat) {
      case "units":
        this.product.unitId = "";
        break;
      case "groups":
        this.product.groupId = "";
        break;
      case "categories":
        this.product.categoryId = "";
        break;
      case "suppliers":
        this.product.supplierId = "";
        break;
      case "producers":
        this.product.producerId = "";
        break;
      case "origins":
        this.product.originId = "";
        break;
      case "sizes":
        this.product.sizeId = "";
        break;
      case "colors":
        this.product.colorId = "";
        break;
      default:
        break;
    }
  }

  calculatorPrice(value: number) {
    console.log("calculatorPrice:", value);
    if (value > 0 && this.product.costPrice > 0) {
      this.ratePrice = value;
      this.product.price =
        parseFloat(this.product.costPrice.toString()) +
        Math.round((this.product.costPrice * value) / 100 + Number.EPSILON);
    }
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
